import styled from 'styled-components';
import MuiToolbar from "@material-ui/core/Toolbar";

export const StyledMuiToolbar = styled(MuiToolbar)`
  background: #26427C;
`;
